
import DoseFormTable from 'components/DoseForm';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const DoseForm = () => {
  const selectedCompanyPermission = useSelector(
    (state: any) => state?.userProfile?.data?.permissions
  );
  const isDoseFormsPermission = checkPermission(selectedCompanyPermission, {
    permissionName: 'DoseForm',
    permission: ['viewAll'],
  });
  return <div>{isDoseFormsPermission && <DoseFormTable />}</div>;
};
